import { render, staticRenderFns } from "./tishi1.vue?vue&type=template&id=15b31484&scoped=true&"
import script from "./tishi1.vue?vue&type=script&lang=js&"
export * from "./tishi1.vue?vue&type=script&lang=js&"
import style0 from "./tishi1.vue?vue&type=style&index=0&id=15b31484&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b31484",
  null
  
)

export default component.exports